// import Router from "vue-router";
import { createWebHistory, createRouter } from "vue-router";
import store from "@/store";
import {
  isChatOnlyBlockedRoute,
  isChatOnlyLocked,
  isLivestreamManageBlocked,
} from "@/composables/useChatOnlyLock";
import { redirectAfterAuth } from "@/Utils/authRedirect";

import SignIn from "@/views/SignIn";
import SignInAdmin from "@/views/SignInAdmin.vue";
import TwoFactorVerification from "@/views/TwoFactorVerification";
import Dashboard from "@/views/Dashboard";
import StreamManage from "@/views/StreamsDash/StreamsManage";
import VODStreamManage from "@/views/VodDash/VODStreamManage";
import VODFolderManage from "@/views/VodDash/VODFolderManage";
import StreamManageDashboard from "@/views/StreamsDash/StreamsManageDashboard";
import StreamsManageSettings from "@/views/StreamsDash/StreamsManageSettings";
import StreamsManageSettingsPlayerInterface from "@/views/StreamsDash/StreamsManageSettingsPlayerInterface";
import StreamsManageSettingsPlayerFunctions from "@/views/StreamsDash/StreamsManageSettingsPlayerFunctions";
import StreamsManageSettingsAdaptiveBitrate from "@/views/StreamsDash/StreamsManageSettingsAdaptiveBitrate";
import StreamsManageSettingsBackup from "@/views/StreamsDash/StreamsManageSettingsBackup";
import VODBucketPlayerSettings from "@/views/StreamsDash/VODBucketPlayerSettings";
import StreamsManageAnalytics from "@/views/StreamsDash/StreamsManageAnalytics.vue";
import StreamsManageAnalyticsInputHealthCharts from "@/views/StreamsDash/StreamsManageAnalyticsInputHealthCharts.vue";
import StreamsManageAnalyticsLiveInputHealthCharts from "@/views/StreamsDash/StreamsManageAnalyticsLiveInputHealthCharts.vue";
import StreamsManageSecuritySettings from "@/views/StreamsDash/StreamsManageSecuritySettings";
import StreamManageVodEpisodes from "@/views/StreamsDash/StreamsManageVodEpisodes";
import StreamManageClipEpisodes from "@/views/StreamsDash/StreamsManageClipEpisodes";
import StreamsManageAlerts from "@/views/StreamsDash/StreamsManageAlerts";
import StreamsManageNotifications from "@/views/StreamsDash/StreamsManageNotifications";
import StreamsManageWebhooks from "@/views/StreamsDash/StreamsManageWebhooks";
import VODBucket from "@/views/VodDash/VODBucket";
import VODTagsManage from "@/views/VodDash/VODTagsManage";
import Scheduler from "@/views/SchedulerDash/SchedulerDashboard";

import DynamicDashboard from "@/views/DynamicDash/DynamicDashboard";
import DynamicManage from "@/views/DynamicDash/DynamicManage";

import PlayoutDashboard from "@/views/TVPlayoutDash/PlayoutDashboard";
import PlayoutDashboardV2 from "@/views/TVPlayoutDash/PlayoutDashboardV2";
import PlayoutView from "@/views/TVPlayoutDash/PlayoutView";
import PlayoutViewV2 from "@/views/TVPlayoutDash/PlayoutViewV2";

import ManageHighlights from "@/views/Highlights/ManageHighlights";
import StreamManageHighlights from "@/views/Highlights/StreamManageHighlights";

import CaptioningDashboard from "@/views/Captioning/CaptioningDashboard";
import CaptioningManage from "@/views/Captioning/CaptioningManage";

import DestinationDashboard from "@/views/Destination/DestinationDashboard";

import StreamsManageShowcase from "@/views/Showcase/StreamsManageShowcase";
import ManagePlaylists from "@/views/Playlists/ManagePlaylists";
import ManagePlaylist from "@/views/Playlists/ManagePlaylist";
import StreamsManagePaywall from "@/views/StreamsDash/StreamsManagePaywall";
import AnalyticsDashboard from "@/views/AnalyticsDash/AnalyticsDashboard";
import StreamsManageAdvertising from "@/views/StreamsDash/StreamsManageAdvertising";
import StreamsManageAudience from "@/views/StreamsDash/StreamsManageAudience";
import StreamsManageAudienceLiveRoom from "@/views/StreamsDash/StreamsManageAudienceLiveRoom";
import StreamsManageAudiencePanelSetup from "@/views/StreamsDash/StreamsManageAudiencePanelSetup";
import StreamsManageAudienceEmailCapture from "@/views/StreamsDash/StreamsManageAudienceEmailCapture";
import StreamsManageAudienceContacts from "@/views/StreamsDash/StreamsManageAudienceContacts";
import Paywall from "@/views/Paywall/PaywallDash";
import OriginManage from "@/views/Origin/OriginManage";

import AppManage from "@/views/AppManage/AppManage";
import ManageAccount from "@/views/AppManage/AppManageAccount";
import ManageTeam from "@/views/AppManage/AppManageTeam";
import ManagePasswordChange from "@/views/AppManage/AppManagePasswordChange";
import ManageInviteFriends from "@/views/AppManage/AppManageInviteFriends";
import ManageBilling from "@/views/AppManage/AppManageBilling";
import ManageDeveloperSettings from "@/views/AppManage/AppManageDeveloperSettings";
import ManageApi from "@/views/AppManage/AppManageApi";
import ManageVmixToken from "@/views/AppManage/AppManageVmixToken";
import ManageOverage from "@/views/AppManage/AppManageOverage";
import ManageCaptioning from "@/views/AppManage/AppManageCaptioning";
import ManageSecurity from "@/views/AppManage/AppManageSecurity";

import Subscribe from "@/views/Subscribe";

import SubSecondDashboard from "@/views/SubSecondStreaming/SubSecondDashboard";
import SubSecondManage from "@/views/SubSecondStreaming/SubSecondManage";
import SubSecondManageDashboard from "@/views/SubSecondStreaming/SubSecondManageDashboard";
import SubSecondSettings from "@/views/SubSecondStreaming/SubSecondSettings";
import SubSecondSecuritySettings from "@/views/SubSecondStreaming/SubSecondSecuritySettings";

import SignUp from "@/views/SignUp";
import RequestPasswordReset from "@/views/RequestPasswordReset";
import ValidatePasswordReset from "@/views/ValidatePasswordReset";

import TranscoderDashboard from "@/views/TranscoderDash/TranscoderDashboard";
import TranscoderManage from "@/views/TranscoderDash/TranscoderManage";

import PaywallManage from "@/views/PaywallDash/PaywallManage";
import SitesDashboard from "@/views/SitesDash/SitesDashboard";
import SiteManage from "@/views/SitesDash/SiteManage";
import SiteOverview from "@/views/SitesDash/manage/SiteOverview";
import SiteContent from "@/views/SitesDash/manage/SiteContent";
import SiteCategories from "@/views/SitesDash/manage/SiteCategories";
import SiteFeatured from "@/views/SitesDash/manage/SiteFeatured";
import SitePages from "@/views/SitesDash/manage/SitePages";
import SitePlans from "@/views/SitesDash/manage/SitePlans";
import SiteViewers from "@/views/SitesDash/manage/SiteViewers";
import SiteTheme from "@/views/SitesDash/manage/SiteTheme";
import SiteDomains from "@/views/SitesDash/manage/SiteDomains";
import SiteTransactions from "@/views/SitesDash/manage/SiteTransactions";
import SiteCalendar from "@/views/SitesDash/manage/SiteCalendar";
import SitePromos from "@/views/SitesDash/manage/SitePromos";
import SiteGeneral from "@/views/SitesDash/manage/SiteGeneral";
import SiteBroadcast from "@/views/SitesDash/manage/SiteBroadcast";
import SiteAudience from "@/views/SitesDash/manage/SiteAudience";
import SiteDonations from "@/views/SitesDash/manage/SiteDonations";

import MultiviewDashboard from "@/views/MultiviewDash/MultiviewDashboard";
import MultiviewContent from "@/views/MultiviewDash/MultiviewContent";
import MediaflowDashboard from "@/views/MediaflowDash/MediaflowDashboard";
import MediaflowContent from "@/views/MediaflowDash/MediaflowContent";

import OttAppsDashboard from "../views/OttApps/OttAppsDashboard.vue";

import UserService from "@/services/UserService";
import InviteLinkPage from "../components/modals/InviteLinkPage.vue";

/* eslint-disable-next-line no-unused-vars */
function isLoggedIn(to, from, next) {
  if (store.state.Auth.isAuthenticated) next();
  else next("/login-redirect");
}

const restrictforTeam = async (to, from, next) => {
  let ownerData = localStorage.getItem("owneruser");
  let user = localStorage.getItem("user");

  if (user) {
    user = JSON.parse(user);
  }

  if (ownerData) {
    ownerData = JSON.parse(ownerData);
  }

  if (ownerData && Object.keys(ownerData).length != 0) {
    let tid = ownerData.id;
    let mid = user._id;
    const permission = await UserService.getMemberpermission(tid, mid);
    if (
      permission &&
      permission.role != "admin" &&
      permission.role !== "moderator"
    ) {
      return next({ path: "/" });
    }
  }
  return next();
};

/* eslint-disable-next-line no-unused-vars */
function loggedInRedirect(to, from, next) {
  // Vuex Auth is not guaranteed to be hydrated when the router runs; use the
  // persisted session instead.
  if (UserService.authenticated()) next("/dashboard");
  else next();
}

function isGuestOnlyRoute(to) {
  return to.matched.some((record) => record.meta && record.meta.guestOnly);
}

// Valid completed session: user + token, and not mid-TOTP. Google SSO a_token
// landings clear `user` before SignIn.tryAutoLogin, so they are not treated as
// authenticated here and can stay on the login page.
function hasCompletedAuthSession(user, twoFactorRequired, twoFactorValidated) {
  if (!UserService.authenticated()) return false;
  const twoFactorPending =
    !twoFactorValidated && (user?.twoFactorEnabled || twoFactorRequired);
  return !twoFactorPending;
}

function redirectAuthUserFromGuestPage(to, cb) {
  // Legacy WP checkout/invite hand-off: honor continue/join instead of dashboard.
  if (to.query && (to.query.continue || to.query.join)) {
    redirectAfterAuth({ signup: false, query: to.query });
    return true;
  }
  cb({ name: "Home" });
  return true;
}

// Vue.use(Router);

const routesLivestreams = {
  path: "/livestreams/:streamId",
  name: "LivestreamManage",
  component: StreamManage,
  // A chat-only moderator lands on the Live room instead of the Dashboard.
  redirect: () => ({
    name: isChatOnlyLocked(store)
      ? "LivestreamManageAudienceLiveRoom"
      : "LivestreamManageDashboard",
  }),
  // Locked routes under here are bounced by the global `beforeEach` below, not by
  // a `beforeEnter`: sibling navigation within these children never re-enters the
  // parent, so a `beforeEnter` would miss Live room -> Dashboard.
  children: [
    {
      path: "dashboard",
      name: "LivestreamManageDashboard",
      component: StreamManageDashboard,
      props: true,
    },
    {
      path: "vodepisodes",
      name: "LivestreamManageVodEpisodes",
      component: StreamManageVodEpisodes,
      props: true,
    },
    {
      path: "clipepisodes",
      name: "LivestreamManageClipEpisodes",
      component: StreamManageClipEpisodes,
      props: true,
    },
    {
      path: "paywall",
      name: "LivestreamManagePaywall",
      component: StreamsManagePaywall,
      props: true,
    },
    {
      path: "advertising",
      name: "StreamsManageAdvertising",
      component: StreamsManageAdvertising,
      props: true,
    },
    {
      path: "audience",
      name: "LivestreamManageAudience",
      component: StreamsManageAudience,
      props: true,
      redirect: {
        name: "LivestreamManageAudienceLiveRoom",
      },
      children: [
        {
          path: "live-room",
          name: "LivestreamManageAudienceLiveRoom",
          component: StreamsManageAudienceLiveRoom,
          props: true,
        },
        {
          path: "panel-setup",
          name: "LivestreamManageAudiencePanelSetup",
          component: StreamsManageAudiencePanelSetup,
          props: true,
        },
        {
          path: "email-capture",
          name: "LivestreamManageAudienceEmailCapture",
          component: StreamsManageAudienceEmailCapture,
          props: true,
        },
        {
          path: "contacts",
          name: "LivestreamManageAudienceContacts",
          component: StreamsManageAudienceContacts,
          props: true,
        },
      ],
    },
    {
      path: "settings",
      name: "LivestreamManageSettings",
      component: StreamsManageSettings,
      props: true,
      redirect: {
        name: "StreamsManageSettingsPlayerInterface",
      },
      children: [
        {
          path: "player-interface",
          name: "StreamsManageSettingsPlayerInterface",
          component: StreamsManageSettingsPlayerInterface,
          props: true,
        },
        {
          path: "player-functions",
          name: "StreamsManageSettingsPlayerFunctions",
          component: StreamsManageSettingsPlayerFunctions,
          props: true,
        },
        {
          path: "security",
          name: "LivestreamManageSecuritySettings",
          component: StreamsManageSecuritySettings,
          props: true,
        },
        {
          path: "adaptive-bitrate",
          name: "StreamsManageSettingsAdaptiveBitrate",
          component: StreamsManageSettingsAdaptiveBitrate,
          props: true,
        },
        {
          path: "alerts",
          name: "StreamsManageAlerts",
          component: StreamsManageAlerts,
          props: true,
          redirect: {
            name: "StreamsManageNotifications",
          },
          children: [
            {
              path: "notifications",
              name: "StreamsManageNotifications",
              component: StreamsManageNotifications,
              props: true,
            },
            {
              path: "webhooks",
              name: "StreamsManageWebhooks",
              component: StreamsManageWebhooks,
              props: true,
            },
          ],
        },
      ],
    },
    {
      path: "backup",
      name: "StreamsManageSettingsBackup",
      component: StreamsManageSettingsBackup,
      props: true,
    },
    {
      path: "analytics",
      name: "LivestreamManageAnalytics",
      props: true,
      component: StreamsManageAnalytics,
      redirect: {
        name: "StreamsManageAnalyticsInputHealthCharts",
      },
      children: [
        {
          path: "input-health",
          name: "StreamsManageAnalyticsInputHealthCharts",
          component: StreamsManageAnalyticsInputHealthCharts,
          redirect: {
            name: "StreamsManageAnalyticsLiveInputHealthCharts",
          },
          children: [
            {
              path: "",
              name: "StreamsManageAnalyticsLiveInputHealthCharts",
              component: StreamsManageAnalyticsLiveInputHealthCharts,
              props: true,
            },
            {
              path: "sessions",
              name: "StreamsManageAnalyticsStreamSessions",
              component: () =>
                import(
                  /* webpackChunkName: 'viewsLivestreams' */ "@/views/StreamsDash/StreamsManageAnalyticsStreamSessions.vue"
                ),
              props: true,
            },
            {
              path: "session-chart/:streamKey/:sessionId",
              name: "StreamSessionsChart",
              component: () =>
                import(
                  /* webpackChunkName: 'viewsLivestreams' */ "@/views/StreamsDash/StreamSessionsChart.vue"
                ),
              props: true,
            },
          ],
        },
      ],
    },
  ],
};

const routesSimulcasts = {
  path: "/multistreams/:streamId",
  name: "SimulcastManage",
  component: StreamManage,
  redirect: {
    name: "SimulcastManageDashboard",
  },
  children: [
    {
      path: "dashboard",
      name: "SimulcastManageDashboard",
      component: StreamManageDashboard,
      props: true,
    },
    {
      path: "chat",
      name: "SimulcastManageChat",
      props: true,
      component: () =>
        import(
          /* webpackChunkName: 'viewsSimulcasts' */ "@/views/StreamsDash/StreamsManageChat.vue"
        ),
    },
    {
      path: "vodepisodes",
      name: "SimulcastManageVodEpisodes",
      component: StreamManageVodEpisodes,
      props: true,
    },
  ],
};

const routesIpcams = {
  path: "/ipcams/:streamId",
  name: "CamstreamManage",
  component: StreamManage,
  redirect: {
    name: "CamstreamManageDashboard",
  },
  children: [
    {
      path: "dashboard",
      name: "CamstreamManageDashboard",
      component: StreamManageDashboard,
      props: true,
    },
    {
      path: "vodepisodes",
      name: "CamstreamManageVodEpisodes",
      component: StreamManageVodEpisodes,
      props: true,
    },
  ],
};

const routesScheduled = {
  path: "/scheduled/:streamId",
  name: "ScheduledStreamManage",
  component: StreamManage,
  redirect: {
    name: "ScheduledStreamManageDashboard",
  },
  children: [
    {
      path: "dashboard",
      name: "ScheduledStreamManageDashboard",
      component: StreamManageDashboard,
      props: true,
    },
  ],
};

const routesHighlight = {
  path: "/highlight/:highlightId",
  name: "HighlightSingleManage",
  component: StreamManageHighlights,
  props: true,
};

const routesVods = {
  path: "/vods/:streamId",
  name: "VODFolderManage",
  component: VODFolderManage,
  redirect: {
    name: "VODBucketVideos",
  },
  children: [
    {
      path: "videos",
      name: "VODBucketVideos",
      props: true,
      component: () =>
        import(
          /* webpackChunkName: 'viewsVods' */ "@/views/VodDash/VODManageVideoList.vue"
        ),
    },
    {
      path: "advertising",
      name: "StreamsManageVodAdvertising",
      component: StreamsManageAdvertising,
      props: true,
    },
    {
      path: "settings",
      name: "VODBucketSettings",
      component: StreamsManageSettings,
      props: true,
      redirect: {
        name: "VODBucketPlayerSettings",
      },
      children: [
        {
          path: "player-interface",
          name: "VODBucketPlayerSettings",
          component: VODBucketPlayerSettings,
          props: true,
        },
        {
          path: "security",
          name: "VODBucketSecuritySettings",
          component: StreamsManageSecuritySettings,
          props: true,
        },
      ],
    },
    {
      path: "paywall",
      name: "VODstreamManagePaywall",
      component: StreamsManagePaywall,
      props: true,
    },
    {
      path: ":videoId/video",
      name: "VODStreamManage",
      component: VODStreamManage,
      props: true,
    },
  ],
};

const routes = [
  {
    path: "/",
    name: "Home",
    redirect: "/dashboard",
  },
  {
    path: "/login",
    alias: ["/signin"],
    name: "Signin",
    component: SignIn,
    meta: {
      fullScreen: true,
      // Already-authenticated users must not sit on sign-in — bounce to dashboard.
      guestOnly: true,
    },
  },
  {
    path: "/admin-login",
    alias: ["/signin-22787"],
    name: "SigninAdmin",
    component: SignInAdmin,
    meta: {
      fullScreen: true,
    },
  },
  {
    path: "/two-factor-verification",
    name: "TwoFactorVerification",
    component: TwoFactorVerification,
    meta: {
      fullScreen: true,
    },
  },
  {
    path: "/login-redirect",
    name: "Login",
    redirect: () => {
      window.location.href = "/app/login";
    },
    meta: {
      fullScreen: true,
    },
  },
  {
    path: "/logout-redirect",
    name: "Logout",
    redirect: () => {
      window.location.href = "/app/logout";
    },
    meta: {
      fullScreen: true,
    },
  },
  {
    path: "/subscribe",
    name: "Payments",
    component: Subscribe,
    beforeEnter: restrictforTeam,
  },
  {
    path: "/signup",
    name: "Signup",
    component: SignUp,
    meta: {
      fullScreen: true,
      guestOnly: true,
    },
  },
  {
    path: "/forgot-password",
    name: "RequestPasswordReset",
    component: RequestPasswordReset,
    meta: {
      fullScreen: true,
    },
  },
  {
    path: "/forgot-password/reset",
    name: "ValidatePasswordReset",
    component: ValidatePasswordReset,
    meta: {
      fullScreen: true,
    },
  },
  {
    path: "/member",
    name: "Member",
    redirect: "/subscribe",
  },
  {
    path: "/vods",
    name: "VodBucket",
    props: true,
    component: VODBucket,
  },
  {
    path: "/vods/tags",
    name: "VODTagsManage",
    props: true,
    component: VODTagsManage,
  },
  {
    path: "/scheduler",
    name: "Scheduler",
    props: true,
    component: Scheduler,
  },
  {
    path: "/",
    name: "Home",
    redirect: "/dashboard",
  },
  {
    path: "/dashboard",
    name: "ChannelList",
    component: Dashboard,
  },
  {
    path: "/login-redirect",
    name: "Login",
    redirect: () => {
      window.location.href = "/app/login";
    },
    meta: {
      fullScreen: true,
    },
  },
  {
    path: "/manage",
    name: "AppManage",
    // redirect: '/manage/account',
    component: AppManage,
    children: [
      {
        path: "account",
        meta: {
          title: "Account",
        },
        component: ManageAccount,
      },
      {
        path: "team",
        name: "Team",
        meta: {
          title: "Team",
        },
        component: ManageTeam,
      },
      {
        path: "change-password",
        meta: {
          title: "Change Password",
        },
        component: ManagePasswordChange,
      },
      {
        path: "billing",
        name: "Billing",
        meta: {
          title: "Billing",
        },
        component: ManageBilling,
      },
      {
        path: "developers",
        meta: {
          title: "LiveU Key",
        },
        component: ManageDeveloperSettings,
      },
      {
        path: "api",
        meta: {
          title: "Developer API",
        },
        component: ManageApi,
      },
      {
        path: "vmix-token",
        meta: {
          title: "vMix Token",
        },
        component: ManageVmixToken,
      },
      {
        path: "captioning",
        name: "ManageCaptioning",
        meta: {
          title: "Captioning",
        },
        component: ManageCaptioning,
      },
      {
        path: "overage",
        meta: {
          title: "Overage",
        },
        component: ManageOverage,
      },
      {
        path: "refer-and-earn",
        meta: {
          title: "Refer and Earn",
        },
        component: ManageInviteFriends,
      },
      {
        path: "security",
        meta: {
          title: "Security",
        },
        component: ManageSecurity,
      },
    ],
  },
  {
    path: "/member",
    name: "Member",
    redirect: "/subscribe",
  },
  {
    path: "/scheduler",
    name: "Scheduler",
    props: true,
    component: Scheduler,
  },
  {
    path: "/paywall",
    name: "Paywall",
    props: true,
    component: Paywall,
  },
  {
    path: "/playlists",
    name: "Playlists",
    props: true,
    component: ManagePlaylists,
  },
  {
    path: "/activity-log",
    name: "ActivityLog",
    component: () => import("@/views/ActivityLog/ActivityLog.vue"),
  },
  {
    path: "/playlists/:playlistId",
    name: "Playlist",
    props: true,
    component: ManagePlaylist,
  },
  {
    path: "/showcase",
    name: "Showcase",
    props: true,
    component: StreamsManageShowcase,
    redirect: {
      name: "ShowcaseContent",
    },
    children: [
      {
        path: "content",
        name: "ShowcaseContent",
        props: true,
        component: () => import("@/views/Showcase/ShowcaseContent.vue"),
      },
      {
        path: "settings",
        name: "ShowcaseSettings",
        props: true,
        component: () => import("@/views/Showcase/ShowcaseSettings.vue"),
      },
    ],
  },
  {
    path: "/paywall",
    name: "Paywall",
    // redirect: '/paywall/subscriptions',
    // component: () => import('@/views/Billing'),
    props: true,
    component: Paywall,
  },
  {
    path: "/highlight",
    name: "Highlight",
    props: true,
    component: ManageHighlights,
  },
  {
    path: "/captioning",
    name: "Captioning",
    component: CaptioningDashboard,
  },
  {
    path: "/captioning/:flowId",
    name: "CaptioningManage",
    component: CaptioningManage,
    props: true,
  },
  routesLivestreams,
  routesSimulcasts,
  routesIpcams,
  routesScheduled,
  routesHighlight,
  routesVods,
  {
    path: "/dynamic",
    name: "DynamicDashboard",
    component: DynamicDashboard,
    // redirect: {
    // 	name: 'DynamicDashboard'
    // },
    children: [],
  },
  {
    path: "/dynamic/:playerId",
    name: "DynamicManage",
    component: DynamicManage,
    props: true,
  },
  {
    path: "/analytics/:videoId",
    name: "AnalyticsDashboardWithRoute",
    component: AnalyticsDashboard,
    children: [],
  },
  {
    path: "/analytics",
    name: "AnalyticsDashboard",
    component: AnalyticsDashboard,
    children: [],
  },
  {
    path: "/tv-playout",
    name: "TVPlayoutDashboard",
    component: PlayoutDashboard,
    children: [],
    meta: {
      title: "TV playouts",
    },
  },
  {
    path: "/tv-playout/v2",
    name: "TVPlayoutDashboardV2",
    component: PlayoutDashboardV2,
    children: [],
    meta: {
      title: "TV playouts",
    },
  },
  {
    path: "/tv-playout/:tvId",
    name: "PlayoutView",
    component: PlayoutView,
    children: [],
    meta: {
      title: "TV playout",
    },
  },
  {
    path: "/tv-playout/v2/:tvId",
    name: "PlayoutViewV2",
    component: PlayoutViewV2,
    children: [],
    meta: {
      title: "TV playout",
    },
  },
  {
    path: "/sub-second",
    name: "SubSecondDashboard",
    component: SubSecondDashboard,
    children: [],
    meta: {
      title: "Sub Second Streaming",
    },
  },
  {
    path: "/sub-second/:streamId",
    name: "SubSecondManage",
    component: SubSecondManage,
    redirect: {
      name: "SubSecondManageDashboard",
    },
    children: [
      {
        path: "dashboard",
        name: "SubSecondManageDashboard",
        component: SubSecondManageDashboard,
        props: true,
      },
      {
        path: "analytics",
        name: "SubSecondManageAnalytics",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: 'viewsLivestreams' */ "@/views/StreamsDash/StreamsManageAnalytics.vue"
          ),
        redirect: {
          name: "SubSecondManageAnalyticsInputHealthCharts",
        },
        children: [
          {
            path: "input-health",
            name: "SubSecondManageAnalyticsInputHealthCharts",
            component: StreamsManageAnalyticsInputHealthCharts,
            redirect: {
              name: "SubSecondManageAnalyticsLiveInputHealthCharts",
            },
            children: [
              {
                path: "",
                name: "SubSecondManageAnalyticsLiveInputHealthCharts",
                component: StreamsManageAnalyticsLiveInputHealthCharts,
                props: true,
              },
              {
                path: "sessions",
                name: "SubSecondManageAnalyticsStreamSessions",
                component: () =>
                  import(
                    /* webpackChunkName: 'viewsLivestreams' */ "@/views/StreamsDash/StreamsManageAnalyticsStreamSessions.vue"
                  ),
                props: true,
              },
            ],
          },
        ],
      },
      {
        path: "settings",
        name: "SubSecondSettings",
        component: SubSecondSettings,
        props: true,
        redirect: {
          name: "SubSecondSecuritySettings",
        },
        children: [
          {
            path: "security",
            name: "SubSecondSecuritySettings",
            component: SubSecondSecuritySettings,
            props: true,
          },
        ],
      },
    ],
  },
  {
    path: "/origin",
    name: "Origin",
    component: OriginManage,
  },
  {
    path: "/transcoder",
    name: "TranscoderDashboard",
    component: TranscoderDashboard,
    children: [],
  },
  {
    path: "/transcoder/:transcoderId",
    name: "TranscoderManage",
    component: TranscoderManage,
    props: true,
  },
  {
    path: "/paywall/v2",
    name: "PaywallManage",
    props: true,
    component: PaywallManage,
  },
  {
    path: "/paywall/v2/:paywallId",
    name: "PaywallItem",
    props: true,
    component: PaywallManage,
  },
  {
    path: "/sites",
    name: "SitesDashboard",
    component: SitesDashboard,
    meta: {
      title: "Sites",
    },
  },
  {
    path: "/sites/:siteId",
    props: true,
    component: SiteManage,
    meta: {
      title: "Sites",
    },
    // Each section is its own route so it is linkable; the shell passes the
    // loaded site down as a prop. Sections are grouped (Content · Monetize ·
    // Audience · Settings, see views/SitesDash/siteNav.js); the route names
    // are the stable API and the old flat paths redirect.
    children: [
      { path: "", name: "SiteManage", redirect: { name: "SiteOverview" } },
      { path: "overview", name: "SiteOverview", component: SiteOverview, props: true },
      { path: "content", name: "SiteContent", component: SiteContent, props: true },
      { path: "content/categories", name: "SiteCategories", component: SiteCategories, props: true },
      { path: "content/featured", name: "SiteFeatured", component: SiteFeatured, props: true },
      { path: "content/pages", name: "SitePages", component: SitePages, props: true },
      { path: "content/calendar", name: "SiteCalendar", component: SiteCalendar, props: true },
      { path: "monetize", redirect: { name: "SitePlans" } },
      { path: "monetize/plans", name: "SitePlans", component: SitePlans, props: true },
      { path: "monetize/promos", name: "SitePromos", component: SitePromos, props: true },
      { path: "monetize/transactions", name: "SiteTransactions", component: SiteTransactions, props: true },
      // Broadcast template: native donations (sites-broadcast-template-contract.md §7)
      { path: "monetize/donations", name: "SiteDonations", component: SiteDonations, props: true },
      { path: "audience", redirect: { name: "SiteViewers" } },
      { path: "audience/viewers", name: "SiteViewers", component: SiteViewers, props: true },
      { path: "settings", redirect: { name: "SiteTheme" } },
      // Broadcast template: service info, chat and giving
      { path: "settings/broadcast", name: "SiteBroadcast", component: SiteBroadcast, props: true },
      // Broadcast template: audience preset + register-to-watch (site-admin API v0.19)
      { path: "settings/audience", name: "SiteAudience", component: SiteAudience, props: true },
      // `section` = theme sub-tab (branding | layout | sections | player | texts | access | footer)
      { path: "settings/theme/:section?", name: "SiteTheme", component: SiteTheme, props: true },
      { path: "settings/domains", name: "SiteDomains", component: SiteDomains, props: true },
      { path: "settings/general", name: "SiteGeneral", component: SiteGeneral, props: true },
      // Pre-grouping deep links (bookmarks, emails, older tests).
      { path: "categories", redirect: (to) => ({ name: "SiteCategories", params: to.params, query: to.query }) },
      { path: "featured", redirect: (to) => ({ name: "SiteFeatured", params: to.params, query: to.query }) },
      { path: "pages", redirect: (to) => ({ name: "SitePages", params: to.params, query: to.query }) },
      { path: "calendar", redirect: (to) => ({ name: "SiteCalendar", params: to.params, query: to.query }) },
      {
        path: "plans",
        redirect: (to) => {
          const { view, ...query } = to.query;
          return { name: view === "promos" ? "SitePromos" : "SitePlans", params: to.params, query };
        },
      },
      { path: "promos", redirect: (to) => ({ name: "SitePromos", params: to.params, query: to.query }) },
      { path: "viewers", redirect: (to) => ({ name: "SiteViewers", params: to.params, query: to.query }) },
      { path: "transactions", redirect: (to) => ({ name: "SiteTransactions", params: to.params, query: to.query }) },
      { path: "theme", redirect: (to) => ({ name: "SiteTheme", params: to.params, query: to.query }) },
      { path: "domains", redirect: (to) => ({ name: "SiteDomains", params: to.params, query: to.query }) },
      { path: "general", redirect: (to) => ({ name: "SiteGeneral", params: to.params, query: to.query }) },
    ],
  },
  {
    path: "/destination",
    name: "DestinationDashboard",
    component: DestinationDashboard,
    children: [],
  },
  {
    path: "/multiview",
    name: "MultiviewDashboard",
    component: MultiviewDashboard,
    children: [],
    meta: {
      title: "Multiview",
    },
  },
  {
    path: "/multiview/:id",
    name: "MultiviewContent",
    component: MultiviewContent,
    props: true,
    children: [],
  },
  {
    path: "/cloud-production",
    name: "MediaflowDashboard",
    component: MediaflowDashboard,
    children: [],
    meta: {
      title: "Mediaflow",
    },
  },
  {
    path: "/cloud-production/:id",
    name: "MediaflowContent",
    component: MediaflowContent,
    props: true,
    children: [],
  },
  {
    path: "/ott-apps",
    name: "OttApps",
    component: OttAppsDashboard,
  },
  {
    path: "/invite-link/:id",
    name: "InviteLinkPage",
    component: InviteLinkPage,
    meta: {
      fullScreen: true,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "notfound",
    component: async () => await import("@/views/404.vue"),
  },
];

const router = createRouter({
  base: "/app/",
  history: createWebHistory(),
  routes,
});

const GuestPages = [
  "Signin",
  "SigninAdmin",
  "Signup",
  "RequestPasswordReset",
  "ValidatePasswordReset",
  "signin",
  "login",
  // Unknown URLs (`notfound`) are not guest pages: logged-out visitors go to
  // sign-in instead of the authed 404 shell. Logged-in users still see 404.
  "InviteLinkPage",
  "TwoFactorVerification",
];

router.beforeEach((to, from, cb) => {
  // Check for 2FA requirement in localStorage
  const tempAuthKey = localStorage.getItem("token");
  const twoFactorRequired = localStorage.getItem("twoFactorRequired");
  const twoFactorValidated = localStorage.getItem("twoFactorValidated");
  const user = UserService.getUser();

  if (to.name === "TwoFactorVerification" && !tempAuthKey) {
    return cb("/login");
  }

  if (to.name === "TwoFactorVerification" && tempAuthKey) {
    // Already past TOTP: no reason to sit on the 2FA screen.
    if (hasCompletedAuthSession(user, twoFactorRequired, twoFactorValidated)) {
      return cb({ name: "Home" });
    }
    return cb();
  }

  if (tempAuthKey && (user?.twoFactorEnabled || twoFactorRequired) && !twoFactorValidated) {
    if (to.name === "Signin") {
      localStorage.removeItem("token");
      return cb();
    }
    if (to.name === "ChannelList") {
      console.log("2FA required, redirecting to verification page");
      return cb("/two-factor-verification");
    }
  }

  // Unknown URL (catch-all `notfound`): send a logged-in user to their
  // dashboard instead of the authed 404 shell. A logged-out visitor falls
  // through to the sign-in redirect below (notfound is intentionally NOT a
  // GuestPage, so `/logintest`-style typos still land on sign-in).
  if (to.name === "notfound" && UserService.authenticated()) {
    return cb({ name: "Home" });
  }

  // "Moderate Chat only": keep the member on the livestream Chat tab. Scoped to
  // the LivestreamManage subtree because `isChatOnlyBlockedRoute` answers "is this
  // one of the two allowed livestream routes", which is false for the whole rest
  // of the app. Permissions are hydrated in StreamsManage's onMounted, so a cold
  // load evaluates as NOT locked and passes through — bouncing owners to the Chat
  // tab on every cold load would be far worse, and the API is the real boundary.
  // StreamsManage watches the lock and replaces the route once it resolves.
  if (to.matched.some((record) => record.name === "LivestreamManage")) {
    // View alone grants the stream list, not the manage page. A moderator who is
    // neither Edit-or-higher nor chat-only is sent back to the list rather than
    // shown a page on which every single control is disabled.
    if (isLivestreamManageBlocked(store)) {
      return cb({ name: "ChannelList" });
    }
    if (isChatOnlyLocked(store) && isChatOnlyBlockedRoute(to.name)) {
      return cb({
        name: "LivestreamManageAudienceLiveRoom",
        params: to.params,
      });
    }
  }

  // Sign-in / sign-up (guestOnly): a completed session never stays here.
  // Runs for both SSO (`twoFactorValidated`) and regular logins — the old
  // early-return on `twoFactorValidated` skipped GuestPages and left SSO
  // users on the login screen. Password reset, admin login, and invite links
  // stay reachable when logged in. Unknown URLs are not guest pages, so a
  // logged-out visitor is sent to sign-in instead of the 404 shell.
  if (
    isGuestOnlyRoute(to) &&
    hasCompletedAuthSession(user, twoFactorRequired, twoFactorValidated)
  ) {
    if (redirectAuthUserFromGuestPage(to, cb)) return;
  }

  if (twoFactorValidated) {
    return cb();
  }

  // we can't use here vuex state here, router called before state loaded
  // TODO: check if vuex state loaded, and if not loaded load
  const loggedin = UserService.authenticated();
  if (GuestPages.indexOf(to.name) > -1) {
    if (loggedin) {
      // Honor the legacy WP contract: a logged-in user hitting a guest page
      // (e.g. a "subscribe to package X" link -> /app/signup?continue=subscribe
      // &_package=...) should be sent to the continue target (checkout), not
      // bounced to the dashboard. Full-page redirect, so don't call cb().
      if (redirectAuthUserFromGuestPage(to, cb)) return;
    }
  } else {
    if (!loggedin && GuestPages.indexOf(to.name) === -1) {
      console.log("auth redirect: router", to.name);
      // Not authenticated on a protected route: send to the sign-in page.
      // In-app redirect (not window.location) avoids a full page reload,
      // and "Signin" is a GuestPage so this won't loop.
      return cb({ name: "Signin" });
    }
  }

  // Phone number check removed - only load contacts when actually needed
  // (on account management page or notifications page)

  cb();
});

export default router;
